<script>
import Drawer from "@/components/drawer";
import moment from "moment";

// Custom Components
import UserService from "@/helpers/APIService/user.service";
import Middleware from "@/helpers/middlewares";
import errorHandler from "@/helpers/errorHandler";
import PbxService from "@/helpers/APIService/pbx.service";
import { authComputed, authMethods } from "@/state/helpers";
import HandleLogic from "@/helpers/handleLogic";
import { project_type, non_super_user } from "@/helpers/global.variable";

// Nav-bar Component

export default {
  name: "nav-bar",
  data() {
    return {
      text: "",
      auditDate: moment().format("YYYY-MM-DD"),
      isDataSyncing: false,
      syncLastTime: "",
      isOpenSessionUpdateCount: 0,
      errorMessage: "",
      sessionId: "",
      isShowStartNewDay: false,
      unreadNotifications: 0,
      domainList: [],
      isShowForm: false,
      domain_search_keyward: "",
      domainTitle: "Domains",
      AdminUsers: ["super_admin", "pbx_admin_staff"],
      project_type,
      non_super_user,
      isDomainLoading: false,
      currentProjectType: "",
      theNewValueChange: false,
      isPhilippines: false,
    };
  },
  computed: {
    ...authComputed,
    filteredDomain() {
      return this.domainList.filter((item) =>
        item.domain_name
          .toLowerCase()
          .includes(this.domain_search_keyward.toLowerCase())
      );
    },
  },
  watch: {
    $route(to, from) {
      this.getPMSConnection();
      if (to.path != from.path) {
        if (this.theNewValueChange) {
          this.theNewValueChange = false;
          this.$router.go();
        }
      }
    },
  },
  components: {
    Drawer,
  },
  mounted() {
    this.getUnreadNotificationCount();
    this.avatarGenerator();
    this.toggleMenu();
    this.setNightAudit();
    this.getPMSConnection();
    this.$root.$on("last_audit_update", (data) => {
      this.auditDate = data;
      this.setNightAudit();
    });
    this.$root.$on("change_image", () => {
      const data = JSON.parse(localStorage.getItem("user"));
      this.user.user.profile_picture = data.user.profile_picture;
    });
    this.$root.$on("notificatinRead", () => {
      this.getUnreadNotificationCount();
    });
    this.defautlProjectType();
  },
  methods: {
    ...authMethods,
    // Method is used to set night audit date
    setNightAudit() {
      if (this.hotel !== null) {
        if (localStorage.last_audit) {
          this.auditDate = localStorage.getItem("last_audit");
        }
        const dateDiff =
          moment(this.auditDate).format("YYYY-MM-DD") <
          moment().format("YYYY-MM-DD");
        if (dateDiff) {
          this.isShowStartNewDay = true;
        } else {
          this.isShowStartNewDay = false;
        }
      }
    },
    toggleMenu() {
      this.$parent.toggleMenu();
    },
    // Method is used to toggle side bar
    toggleRightSidebar() {
      this.$parent.toggleRightSidebar();
    },
    // Method is used to make screen as full screen
    redirectToInbox() {
      if (this.$route.path != "/inbox") {
        this.$router.push("/inbox");
      }
    },
    // Method is used to handle hotel change
    changeHotel(hotel_id) {
      UserService.updateProfile({ user_hotel: hotel_id })
        .then(() => {
          this.setHotel(hotel_id).then(() => {
            this.$router.go();
          });
        })
        .catch((error) => {
          if (error.response.status == 401) {
            if (error.response.data.code == "user_not_found") {
              this.$router.push("/logout");
              this.logout();
            }
          }
        });
    },

    defautlProjectType() {
      if (localStorage.is_philippines) {
        this.isPhilippines = true;
      }
      if (this.user.user.user_type == "super_admin") {
        this.currentProjectType =
          localStorage.getItem("current_project_type") != undefined
            ? localStorage.getItem("current_project_type")
            : "all";
      } else {
        this.currentProjectType =
          localStorage.getItem("current_project_type") != undefined
            ? localStorage.getItem("current_project_type")
            : "All";
      }
    },
    // Change Drop Down in Super User
    changeProject(type) {
      localStorage.setItem("current_project_type", type);
      this.currentProjectType = type;

      if (this.currentProjectType === "all") {
        this.theNewValueChange = true;
        if (this.$route.path != "/kiosk-status") {
          this.$router.push("/kiosk-status");
        }
      }
      if (this.currentProjectType == "CloudExt PBX") {
        this.theNewValueChange = true;
        if (this.$route.path != "/server-health") {
          this.$router.push("/server-health");
        }
      }
      if (this.currentProjectType == "kiosk") {
        this.theNewValueChange = true;
        if (this.$route.path != "/kiosk-status") {
          this.$router.push("/kiosk-status");
        }
      }
      if (this.currentProjectType == "lock") {
        this.theNewValueChange = true;
        if (this.$route.path != "/gateway") {
          this.$router.push("/gateway");
        }
      }
      if (this.currentProjectType == "guest_xp_app") {
        this.theNewValueChange = true;
        if (this.$route.path != "/hotel-list") {
          this.$router.push("/hotel-list");
        }
      }
      if (this.currentProjectType == "video_bot") {
        this.theNewValueChange = true;
        this.$router.push("/ai-bot/hotel-list");
      }
      if (this.currentProjectType == "super_admin") {
        this.theNewValueChange = true;
        if (this.$route.path != "/hotel-list") {
          this.$router.push("/hotel-list");
        }
      }
      if (this.currentProjectType == "ID Scan Desktop") {
        this.theNewValueChange = true;
        if (this.$route.path != "/id-scan-desktop") {
          this.$router.push("/id-scan-desktop");
        }
      }
    },
    // Change Drop Down in Non Super User types
    changeBaseProject(type) {
      localStorage.setItem("current_project_type", type);
      this.currentProjectType = type;

      if (this.currentProjectType === "All") {
        this.theNewValueChange = true;
        if (this.$route.path != "/dashboard") {
          this.$router.push("/dashboard");
        }
      }
      if (this.currentProjectType == "booking") {
        this.theNewValueChange = true;
        if (this.$route.path != "/booking") {
          this.$router.push("/booking");
        }
      }
      if (this.currentProjectType == "kiosk_Admin") {
        this.theNewValueChange = true;
        if (this.$route.path != "/kiosk-machine-setting") {
          this.$router.push("/kiosk-machine-setting");
        }
      }
      if (this.currentProjectType == "settings") {
        this.theNewValueChange = true;
        if (this.$route.path != "/hotel") {
          this.$router.push("/hotel");
        }
      }
      if (this.currentProjectType == "requests") {
        this.theNewValueChange = true;
        if (this.$route.path != "/inbox") {
          this.$router.push("/inbox");
        }
      }
      if (this.currentProjectType == "misc") {
        this.theNewValueChange = true;
        if (this.$route.path != "/user-review") {
          this.$router.push("/user-review");
        }
      }
      if (this.currentProjectType == "ID Scan Desktop") {
        this.theNewValueChange = true;
        if (this.$route.path != "/id-scan-desktop") {
          this.$router.push("/id-scan-desktop");
        }
      }
    },
    // Method is use for generate a avatar
    avatarGenerator() {
      return Middleware.avatarGenerator(
        this.user.user.first_name + " " + this.user.user.last_name
      );
    },
    // Method is use for redirect to night audit page
    redirectToNightAudit() {
      if (this.$route.path == "/booking") {
        this.$router.push({ path: "/booking/audit/night" });
      }
    },
    // Method is used to GET PMS connection
    async getPMSConnection(data) {
      if (
        this.user &&
        this.user.user.user_type !== "super_admin" &&
        this.hotel !== null &&
        this.hotel.is_pms_connection
      ) {
        try {
          const filter = "?operation_type=booking&size=1";
          const response = await UserService.getPMSSyncRecord(filter);
          if (response.results.length !== 0) {
            this.syncLastTime = moment(
              response.results[0].created_at
            ).fromNow();
            if (!localStorage.isPmsConnected) {
              localStorage.setItem(
                "isPmsConnected",
                JSON.stringify({
                  status: true,
                  pmsType: response.results[0].pms_connection.pms_type,
                })
              );
            }
            if (
              response.results[0].pms_connection.pms_type == "jonas_chorum_pms"
            ) {
              this.sessionId =
                localStorage.session_id !== undefined
                  ? localStorage.getItem("session_id")
                  : "";
              if (
                localStorage.session_id == undefined &&
                this.$route.path == "/dashboard"
              ) {
                this.$bvModal.show("pms-session-id");
              }
            }
          } else {
            this.syncLastTime = "Not sync at";
            localStorage.setItem(
              "isPmsConnected",
              JSON.stringify({
                status: false,
              })
            );
          }
          if (data !== undefined) {
            let interValId = "";
            interValId = setInterval(() => {
              const filter = "?operation_type=booking&size=1";
              UserService.getPMSSyncRecord(filter).then((pmsResponse) => {
                if (pmsResponse.results.length !== 0) {
                  if (pmsResponse.results[0].id !== data.id) {
                    this.isDataSyncing = false;
                    Middleware.notification(
                      "New data synced successfully !!",
                      "success",
                      1500
                    );
                    clearInterval(interValId);
                    this.$router.go();
                  } else {
                    this.syncLastTime = moment(
                      pmsResponse.results[0].created_at
                    ).fromNow();
                    this.isDataSyncing = true;
                  }
                }
              });
            }, 15000);
          } else {
            this.syncLastTime = moment(
              response.results[0].created_at
            ).fromNow();
            this.isDataSyncing = false;
          }
        } catch (error) {
          if (error.response.status !== 404) {
            errorHandler(error);
          } else {
            this.isDataSyncing = false;
            localStorage.setItem(
              "isPmsConnected",
              JSON.stringify({
                status: false,
              })
            );
          }
        }
      }
    },
    // Method is used to sync record
    async syncPmsRecord() {
      try {
        this.isDataSyncing = true;
        const filter = "?operation_type=booking&size=1";
        await UserService.syncPMSRecords();
        const response = await UserService.getPMSSyncRecord(filter);
        if (response !== null) {
          this.getPMSConnection(response.results[0]);
        }
      } catch (error) {
        errorHandler(error);
      }
    },
    // Method is used to reset session id
    openResetSessionId() {
      if (this.isPhilippines) {
        return;
      }
      if (this.user.user.user_type !== "super_admin") {
        this.isOpenSessionUpdateCount += 1;
        if (this.isOpenSessionUpdateCount >= 3) {
          this.$bvModal.show("pms-session-id");
        }
      }
    },
    resetModal() {
      this.isOpenSessionUpdateCount = 0;
      this.sessionId = "";
      this.$bvModal.hide("pms-session-id");
    },
    submitData() {
      if (this.sessionId == "") {
        this.errorMessage = "Please Enter Session Id";
      } else {
        localStorage.setItem("session_id", this.sessionId);
        this.resetModal();
      }
    },
    // Method is used to open night audit
    startNewDay() {
      this.$router.push("/booking/audit/night");
    },
    // Method is used to get notification unread count
    getUnreadNotificationCount() {
      UserService.getUnreadNotification()
        .then((response) => {
          this.unreadNotifications = response.unread_notification;
        })
        .catch((error) => {
          errorHandler(error);
        });
    },
    // Method is used to open domain list drawer
    openDomainList() {
      this.isShowForm = true;
      this.domainsList();
    },
    // Method is used to get domain list
    domainsList() {
      if (this.user && this.AdminUsers.includes(this.user.user.user_type)) {
        this.isDomainLoading = true;
        PbxService.getDomainList()
          .then((res) => {
            this.isDomainLoading = false;
            if (res.status == false) {
              return Middleware.notification(res.message, "warning");
            }
            this.domainList = res;
            localStorage.setItem("domain_list", btoa(JSON.stringify(res)));
            this.domainTitle = `Domains (${res.length})`;
          })
          .catch((error) => {
            this.isDomainLoading = false;
            errorHandler(error);
          });
      }
    },
    domainRedirect(domain) {
      HandleLogic.openPbxDomain({ domain_uuid: domain.domain_uuid });
    },
  },
};
</script>

<template>
  <header id="page-topbar">
    <div class="navbar-header">
      <div class="d-flex align-items-center">
        <!-- LOGO -->
        <div class="navbar-brand-box px-0">
          <div class="logo logo-dark">
            <span class="logo-sm" @click="openResetSessionId">
              <h2 class="logo-text mb-0">
                <span class="text-primary">XP</span>
              </h2>
            </span>
            <span class="logo-lg" @click="openResetSessionId">
              <h2 class="logo-text mb-0">
                Guest<span class="text-primary">XP</span>
              </h2>
            </span>
          </div>

          <div class="logo logo-light">
            <span class="logo-sm" @click="openResetSessionId">
              <h2 class="logo-text mb-0">
                <span class="text-primary">XP</span>
              </h2>
            </span>
            <span class="logo-lg" @click="openResetSessionId">
              <h2 class="logo-text mb-0">
                Guest<span class="text-primary">XP</span>
              </h2>
            </span>
          </div>
        </div>
        <button
          id="vertical-menu-btn"
          type="button"
          class="btn btn-sm px-3 font-size-16 header-item"
          @click="toggleMenu"
        >
          <i class="fa fa-fw fa-bars"></i>
        </button>

        <span v-if="!isPhilippines">
          <template>
            <b-dropdown
              right
              variant="black"
              toggle-class="header-item"
              menu-class="dropdown-menu-end"
            >
              <template v-slot:button-content>
                <span class="d-none d-xl-inline-block mx-1 text-capitalize">
                  <h5 class="mb-0">
                    {{ `${currentProjectType.replaceAll("_", " ")}` }}
                  </h5>
                </span>
                <i class="mdi mdi-chevron-down d-none d-xl-inline-block"></i>
              </template>
              <template
                v-if="
                  project_type.length !== 0 &&
                  AdminUsers.includes(user.user.user_type)
                "
              >
                <b-dropdown-item
                  v-for="(item, index) in project_type"
                  :key="index"
                  @click="changeProject(item.value)"
                >
                  <span
                    :class="{
                      'text-primary': item.value === currentProjectType,
                    }"
                  >
                    {{ item.text }}
                  </span>
                </b-dropdown-item>
              </template>
              <template v-else>
                <b-dropdown-item
                  v-for="(item, index) in non_super_user"
                  :key="index"
                  @click="changeBaseProject(item.value)"
                >
                  <span
                    :class="{
                      'text-primary': item.value === currentProjectType,
                    }"
                  >
                    {{ item.text }}
                  </span>
                </b-dropdown-item>
              </template>
            </b-dropdown>
          </template>
        </span>

        <template
          v-if="user && user.user.user_type !== 'super_admin' && hotel !== null"
        >
          <h5
            class="mb-0"
            v-b-popover.hover.bottom="'Redirect to night audit'"
            @click="redirectToNightAudit"
          >
            {{ global_format_date(auditDate) }}
          </h5>
          <div
            class="d-sm-flex align-items-center d-none ms-2"
            v-if="hotel.is_pms_connection"
          >
            <button
              class="btn btn-primary btn-sm"
              @click="syncPmsRecord"
              :disabled="isDataSyncing"
            >
              <i
                v-if="isDataSyncing"
                class="bx bx-loader bx-spin font-size-16 align-middle me-2"
              />
              {{ isDataSyncing ? "Syncing" : "PMS Sync" }}
            </button>
            <i
              v-if="!isDataSyncing"
              class="fa fa-info-circle mb-0 ms-1"
              v-b-popover.hover.top="'Press button to sync new data'"
            />
            <button
              class="btn btn-primary btn-sm ms-2"
              @click="startNewDay"
              v-if="isShowStartNewDay"
            >
              Start New Day
            </button>
            <p class="mb-0 fs-6 ms-1">{{ syncLastTime }}</p>
          </div>
        </template>
      </div>

      <!-- HOTELS -->
      <div class="d-flex" v-if="user">
        <h6
          class="mt-4"
          v-if="user && AdminUsers.includes(user.user.user_type)"
        >
          <a href="#" @click="openDomainList">Domains</a>
        </h6>
        <span v-if="hotel !== null">
          <template>
            <b-dropdown
              right
              variant="black"
              toggle-class="header-item"
              menu-class="dropdown-menu-end"
            >
              <template v-slot:button-content>
                <span class="d-none d-xl-inline-block mx-1">
                  <div>{{ `${hotel.name} - ${hotel.city}` }}</div>
                </span>
                <i class="mdi mdi-chevron-down d-none d-xl-inline-block"></i>
              </template>
              <template v-if="user.user.hotel.length !== 0">
                <b-dropdown-item
                  v-for="(item, index) in user.user.hotel"
                  :key="index"
                  @click="changeHotel(item.id)"
                >
                  <span
                    :class="{
                      'text-primary':
                        item.name === hotel.name && item.city === hotel.city,
                    }"
                  >
                    {{ `${item.name} - ${item.city}` }}
                  </span>
                </b-dropdown-item>
              </template>
              <template v-if="user.user.user_type == 'hotel_admin'">
                <b-dropdown-item @click="$router.push('/hotel-register')">
                  <span class="text-dark">Add New Hotel</span>
                </b-dropdown-item>
              </template>
            </b-dropdown>
          </template>
        </span>

        <!-- INBOX -->
        <div
          class="dropdown d-none d-lg-inline-block"
          v-if="
            (user.user.user_type == 'hotel_admin' ||
              user.user.user_type == 'hotel_staff') &&
            !isPhilippines
          "
        >
          <button
            type="button"
            class="btn header-item noti-icon"
            @click="redirectToInbox"
          >
            <i class="mdi mdi-inbox-arrow-down"></i>
          </button>
        </div>

        <!-- NOTIFICATION -->
        <div v-if="hotel !== null" class="position-relative">
          <button
            class="btn header-item noti-icon"
            @click="
              () => {
                this.$router.push('/notification');
              }
            "
          >
            <i class="bx bx-bell"></i>
            <span class="badge bg-danger rounded-pill">
              {{ unreadNotifications }}
            </span>
          </button>
        </div>

        <!-- PROFILE -->
        <b-dropdown
          right
          variant="black"
          toggle-class="header-item"
          menu-class="dropdown-menu-end"
        >
          <template v-slot:button-content>
            <img
              v-if="user.user.profile_picture !== null"
              class="rounded-circle header-profile-user"
              :src="user.user.profile_picture"
            />
            <div class="avatar-md" v-if="user.user.profile_picture == null">
              <span
                class="avatar-title bg-soft bg-primary text-secondary font-20 rounded-circle"
              >
                {{ avatarGenerator() }}
              </span>
            </div>
            <span class="d-none d-xl-inline-block ms-1">
              <div v-if="user">
                {{ user.user.first_name }}
              </div>
              <div v-else>User</div>
            </span>
            <i class="mdi mdi-chevron-down d-none d-xl-inline-block" />
          </template>
          <!-- ITEM-->
          <router-link
            to="/profile"
            custom
            class="dropdown-item text-primary"
            v-if="!isPhilippines"
          >
            <span>
              <i class="bx bx-user font-size-16 align-middle me-1" />
              Profile
            </span>
          </router-link>
          <a href="/logout" class="dropdown-item text-danger">
            <i
              class="bx bx-power-off font-size-16 align-middle me-1 text-danger"
            />
            Logout
          </a>
        </b-dropdown>
      </div>
    </div>
    <!-- The model is for view image of guest experience -->
    <b-modal
      id="pms-session-id"
      title="Enter PMS Login Session Id (LSID)"
      centered
      hide-footer
      @hidden="resetModal()"
      @close="resetModal()"
      no-close-on-backdrop
    >
      <div class="container">
        <div class="row">
          <div class="col-12">
            <form @submit.prevent="submitData()">
              <div class="form-group">
                <b-form-input
                  id="session_id"
                  type="text"
                  placeholder="Enter PMS Login Session Id"
                  v-model.trim="sessionId"
                  autocomplete="off"
                />
                <p class="mb-0 text-danger p-1" v-if="errorMessage !== null">
                  {{ errorMessage }}
                </p>
              </div>
            </form>
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <b-button
              variant="outline-primary"
              class="float-end mt-1"
              type="submit"
              @click="submitData()"
            >
              Save
            </b-button>
          </div>
        </div>
      </div>
    </b-modal>

    <!-- Drawer is used for display domain list -->
    <Drawer
      @close="isShowForm = !isShowForm"
      :maxWidth="280"
      :align="'right'"
      :closeable="true"
      :maskClosable="true"
      :zIndex="1002"
    >
      <div v-if="isShowForm">
        <h5>{{ domainTitle }}</h5>
        <div class="row">
          <div class="col-md-12">
            <b-form-group class="mb-3" label-for="ip">
              <b-form-input
                placeholder="Domain Search..."
                id="domina_search"
                type="text"
                autocomplete="off"
                v-model="domain_search_keyward"
              />
            </b-form-group>
          </div>
        </div>
        <template v-if="isDomainLoading">
          <ul class="p-0">
            <li class="placeholder-glow my-1" v-for="no in 8" :key="no">
              <div class="placeholder m-0 w-100 placeholder-lg p-3"></div>
            </li>
          </ul>
        </template>
        <template v-else>
          <ul class="domain-list p-0">
            <li
              class="list-group p-2 my-1"
              @click="domainRedirect(item)"
              v-for="(item, index) in filteredDomain"
              :key="index"
            >
              <a target="_blank" class="text-dark" href="#">
                {{ item.domain_name }} ({{ item.pbx }})
              </a>
            </li>
          </ul>
        </template>
      </div>
    </Drawer>
  </header>
</template>

<style>
.logo-text {
  color: black;
  font-size: 36px;
  font-weight: 700;
}

.avatar-title {
  align-items: center;
  color: #fff;
  display: flex;
  height: 100%;
  justify-content: center;
  width: 100%;
}

.domain-list li {
  background-color: #f5f5f5;
  border-radius: 4px;
  transition: all 0.9s ease-out;
}

.domain-list li:hover {
  background-color: #e5e3e3;
}
</style>
